import { render, staticRenderFns } from "./destroy-mining.vue?vue&type=template&id=28ac2b2b&scoped=true&"
import script from "./destroy-mining.vue?vue&type=script&lang=js&"
export * from "./destroy-mining.vue?vue&type=script&lang=js&"
import style0 from "./destroy-mining.vue?vue&type=style&index=0&id=28ac2b2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ac2b2b",
  null
  
)

export default component.exports